function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { ACTIONS } from '@wix/component-protocol/schema';
import { createEditorPlatformManifestServicesError, EditorPlatformManifestServicesErrorCode } from './errors';
var _loadPanelCache = /*#__PURE__*/new WeakMap();
var _PanelLoader_brand = /*#__PURE__*/new WeakSet();
export class PanelLoader {
  constructor() {
    _classPrivateMethodInitSpec(this, _PanelLoader_brand);
    _classPrivateFieldInitSpec(this, _loadPanelCache, new Map());
  }
  load(panelAction, appData) {
    const panelConfig = _assertClassBrand(_PanelLoader_brand, this, _getPanelConfig).call(this, panelAction, appData);
    if (!panelConfig) {
      return null;
    }
    return _assertClassBrand(_PanelLoader_brand, this, _load).call(this, panelConfig);
  }
}
function _load(panelConfig) {
  const {
    bundleUrl
  } = panelConfig;
  if (!bundleUrl) {
    throw createEditorPlatformManifestServicesError(EditorPlatformManifestServicesErrorCode.LoadComponentPanelError, 'No bundleUrl provided for the panel');
  }
  const cached = _classPrivateFieldGet(_loadPanelCache, this).get(bundleUrl);
  if (cached) {
    return cached;
  }
  const loadPanelPromise = _assertClassBrand(_PanelLoader_brand, this, _loadPanel).call(this, panelConfig);
  _classPrivateFieldGet(_loadPanelCache, this).set(bundleUrl, loadPanelPromise);
  loadPanelPromise.finally(() => {
    _classPrivateFieldGet(_loadPanelCache, this).delete(bundleUrl);
  });
  return loadPanelPromise;
}
async function _loadPanel(panelConfig) {
  try {
    const {
      bundleUrl,
      cssUrl
    } = panelConfig;
    if (cssUrl) {
      _assertClassBrand(_PanelLoader_brand, this, _loadCSS).call(this, cssUrl);
    }

    // Import the ESM module
    const module = await _assertClassBrand(_PanelLoader_brand, this, _importModule).call(this, bundleUrl);
    const factory = module.default;
    if (!factory || typeof factory !== 'function') {
      throw createEditorPlatformManifestServicesError(EditorPlatformManifestServicesErrorCode.LoadComponentPanelError, 'invalid loaded panel factory type');
    }
    return factory;
  } catch (error) {
    console.error(error == null ? void 0 : error.message);
    // propagate the error
    throw error;
  }
}
function _loadCSS(cssUrl) {
  if (document.querySelectorAll(`link[href="${cssUrl}"]`).length) {
    return;
  }
  const linkElement = document.createElement('link');
  linkElement.rel = 'stylesheet';
  linkElement.href = cssUrl;
  document.head.appendChild(linkElement);
}
async function _importModule(bundleUrl) {
  try {
    return await import(/* webpackIgnore: true */bundleUrl);
  } catch (error) {
    throw createEditorPlatformManifestServicesError(EditorPlatformManifestServicesErrorCode.LoadComponentPanelError, "failed to import panel's bundle");
  }
}
function _getPanelConfig(panel, appData) {
  switch (panel.panelType) {
    case ACTIONS.PANEL_TYPE.panelId:
      {
        var _appData$components, _panelComponent$data;
        // TODO: check type
        const panelComponent = appData == null || (_appData$components = appData.components) == null ? void 0 : _appData$components.find(component => component.componentId === panel.panelId);
        if (
        // @ts-expect-error no panel related types in app data
        (panelComponent == null || (_panelComponent$data = panelComponent.data) == null ? void 0 : _panelComponent$data.contentType) === ACTIONS.PANEL_CONTENT_TYPE.code) {
          var _panelComponent$data2;
          // @ts-expect-error no panel related types in app data
          return panelComponent == null || (_panelComponent$data2 = panelComponent.data) == null ? void 0 : _panelComponent$data2.code;
        }
        return null;
      }
    case ACTIONS.PANEL_TYPE.inline:
      {
        var _panel$inline;
        if (((_panel$inline = panel.inline) == null ? void 0 : _panel$inline.contentType) === ACTIONS.PANEL_CONTENT_TYPE.code) {
          var _panel$inline2;
          return (_panel$inline2 = panel.inline) == null ? void 0 : _panel$inline2.code;
        }
        return null;
      }
    default:
      {
        return null;
      }
  }
}
//# sourceMappingURL=PanelLoader.js.map